export const thumbWeltingOfUsAtoms = (ctx: CanvasRenderingContext2D, thumbWeltingColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = thumbWeltingColor
  // 親指 1
  ctx.beginPath()
  ctx.moveTo(737, 279) // 上_左
  ctx.quadraticCurveTo(638, 375, 618, 481) // 下_左
  ctx.quadraticCurveTo(623, 474, 623, 474) // 下_右
  ctx.quadraticCurveTo(650, 370, 742, 280) // 上_右
  ctx.quadraticCurveTo(737, 279, 737, 279) // 上_左
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 親指 2
  ctx.beginPath()
  ctx.moveTo(497, 502) // 左＿下
  ctx.quadraticCurveTo(556, 438, 624, 380) // 中間＿右下
  ctx.quadraticCurveTo(646, 362, 657, 378) // 右＿下
  ctx.quadraticCurveTo(660, 371, 660, 374) // 右＿上
  ctx.quadraticCurveTo(645, 358, 628, 371) // 中間＿左上
  ctx.quadraticCurveTo(558, 428, 495, 497) // 左＿上
  ctx.quadraticCurveTo(497, 502, 497, 502) // 左＿下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 親指 3
  ctx.beginPath()
  ctx.moveTo(408, 477) // 上_左
  ctx.quadraticCurveTo(405, 490, 405, 490) // 下_左
  ctx.quadraticCurveTo(410, 490, 410, 490) // 下_右
  ctx.quadraticCurveTo(413, 478, 413, 478) // 上_右
  ctx.quadraticCurveTo(408, 477, 408, 477) // 上_左
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

export const hamidashiOfUsAtoms = (ctx: CanvasRenderingContext2D, weltingColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = weltingColor
  ctx.beginPath()
  ctx.moveTo(215, 153) // 小指 左上
  ctx.quadraticCurveTo(199, 239, 206, 319) // 小指 左下
  ctx.quadraticCurveTo(208, 327, 222, 327) //
  ctx.quadraticCurveTo(235, 320, 244, 333) // 小指 中央右上
  ctx.quadraticCurveTo(249, 375, 273, 428) // 小指 右下 左
  ctx.quadraticCurveTo(276, 419, 275, 419) // 小指 右下 右
  ctx.quadraticCurveTo(256, 373, 248, 330) // 小指 右上
  ctx.quadraticCurveTo(240, 321, 232, 320) //
  ctx.quadraticCurveTo(215, 327, 210, 318) //
  ctx.quadraticCurveTo(202, 222, 219, 149) // 小指 頂点 右
  ctx.quadraticCurveTo(215, 153, 215, 153) //
  // ctx.quadraticCurveTo() //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ctx.beginPath()
  // ctx.moveTo(241, 313) // 小指薬指の間先端
  // ctx.quadraticCurveTo(248, 375, 273, 427) // 小指薬指の間末端左
  // ctx.quadraticCurveTo(277, 427, 277, 427) // 小指薬指の間末端右
  // ctx.quadraticCurveTo(253, 375, 243, 313) // 小指薬指の間先端右
  // ctx.quadraticCurveTo(241, 313, 241, 313) // 小指薬指の間先端左
  // ctx.fill()
  // ctx.stroke()
  // ctx.closePath()

  // 薬指＿中央
  ctx.strokeStyle = '#282828'
  ctx.beginPath()
  ctx.moveTo(275, 92) // 薬指先端＿左
  ctx.quadraticCurveTo(236, 256, 294, 400) // 薬指末端＿左
  ctx.quadraticCurveTo(297, 400, 298, 400) // 薬指末端＿右
  ctx.quadraticCurveTo(240, 250, 279, 90) // 薬指先端＿右
  ctx.quadraticCurveTo(279, 90, 275, 92) // 薬指末端＿左
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 薬指中指の間
  ctx.beginPath()
  ctx.moveTo(305, 262) // 先端＿左
  ctx.quadraticCurveTo(304, 322, 317, 382) // 末端＿左
  ctx.quadraticCurveTo(322, 382, 322, 382) // 末端＿右
  ctx.quadraticCurveTo(308, 322, 308, 262) // 先端＿右
  ctx.quadraticCurveTo(305, 262, 305, 262) // 先端＿左
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 中指中央
  ctx.beginPath()
  ctx.moveTo(373, 37) // 中指先端＿左
  ctx.quadraticCurveTo(311, 190, 338, 368) // 中指末端＿左
  ctx.quadraticCurveTo(343, 368, 343, 368) // 中指末端＿右
  ctx.quadraticCurveTo(315, 190, 377, 37) // 中指先端＿右
  ctx.quadraticCurveTo(373, 37, 373, 37) // 中指先端＿右
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 人差し指＿中央
  ctx.beginPath()
  ctx.moveTo(513, 20) // 先端＿左
  ctx.quadraticCurveTo(426, 157, 402, 356) // 末端＿左
  ctx.quadraticCurveTo(406, 356, 407, 356) // 末端＿右
  ctx.quadraticCurveTo(432, 157, 516, 20) // 先端＿右
  ctx.quadraticCurveTo(514, 20, 513, 20) // 先端＿左
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  thumbWeltingOfUsAtoms(ctx, weltingColor)
}
